import { theme } from '@dls/web';

export default {
  ...theme,
  main: {
    ...theme.main,
    colours: {
      ...theme.main.colours,
      secondary: {
        ...theme.main.colours.secondary
      }
    }
  }
};
